<template lang='pug'>
    v-tabs( color='primary' dark grow )
        v-tab detalle
        v-tab-item
            customer-show-edit
        v-tab info comercial
        v-tab-item
            customer-commercial-info
        v-tab documentos recientes
        v-tab-item
            customer-recent-invoice
        v-tab documentos Con deuda
        v-tab-item
            customer-receivable
        v-tab documentos Morosos
        v-tab-item
            customer-defaulter-invoice-list
        v-tab Nota de crédito
        v-tab-item
            customer-credit-note
        v-tab Nota de débito
        v-tab-item
            customer-debit-note
        v-tab Facturas históricas
        v-tab-item
            customer-historic-invoice
        //- v-tab cuenta corriente
        //- v-tab-item
        //-     customer-current-account
        v-tab Cuenta Corriente
        v-tab-item
            customer-all-historic-document
</template>

<script>

import { mapActions } from 'vuex'
import DetailGeneral from './detail-general'
import CustomerShowEdit from '@/views/Customer/CustomerShowEdit'
import {
    CustomerDetail,
    CustomerReceivableInvoice,
    CustomerRecentInvoice,
    CustomerDefaulterInvoiceList,
    CustomerHistoricInvoice,
    CustomerCurrentAccount,
    CommercialInfo,
    CustomerCreditNote,
    CustomerDebitNote,
    CustomerAllHistoricDocument,
} from './forms/'

// Descuento, Vendedor, Plazo de Pago

export default {
    methods: {

        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
    },
    components: {
        'customer-detail-general'           : DetailGeneral,
        'customer-show-edit'                : CustomerShowEdit,
        'customer-commercial-info'          : CommercialInfo,
        'customer-recent-invoice'           : CustomerRecentInvoice,
        'customer-receivable'               : CustomerReceivableInvoice,
        'customer-defaulter-invoice-list'   : CustomerDefaulterInvoiceList,
        'customer-historic-invoice'         : CustomerHistoricInvoice,
        'customer-current-account'          : CustomerCurrentAccount,
        'customer-credit-note'              : CustomerCreditNote,
        'customer-debit-note'               : CustomerDebitNote,
        'customer-all-historic-document'    : CustomerAllHistoricDocument,
    },
    beforeMount () {
        this.setTitleTopBar( 'Detalle del cliente' )
    },
}
</script>